import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'atram-otp-textbox',
  templateUrl: './atram-otp-textbox.component.html',
  styleUrls: ['./atram-otp-textbox.component.less']
})
export class AtramOtpTextboxComponent implements OnInit {

  public otpCode: string = '';
  @Input()
  parentFormGroup!: FormGroup;
  @Input()
  type!: string;
  @Input()
  controlName!: string;
  @Input()
  label!: string;
  @Input()
  maxlength!: string;
  @Input()
  textColor!: string;
  @Input() isRequired: boolean = false;
  @Input() isError: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input('no-special-char') noSpecialChar: boolean = false; // directive
  @Input('number-only') numberOnly: boolean = false; // directive
  // @Input('upper-case') upperCase: boolean = false; // directive
  @Input()
  componentClass!: string;
  @Output('otp-code')  onOtpEmitter: EventEmitter<string>; 

  constructor() {
    this.onOtpEmitter = new EventEmitter<string>();
 }

  ngOnInit() {
  }

  onDigitInput(event: any){

    let element;
    if (event.code !== 'Backspace' && (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105))
      { 
        element = event.target.nextElementSibling; 
        if(event.srcElement.value){
          event.target.value = event.key;
          this.otpCode += event.srcElement.value;

          if (element == null){
            this.onOtpEmitter.emit(this.otpCode);
          }
        }
      }
 
    if (event.code === 'Backspace' && !event.srcElement.value)
      {
        element = event.target.previousElementSibling;
        // this.otpCode = this.otpCode.slice(0,-1);
      } 

    // if (event.code === 'Backspace' && )
    //   {
    //     this.otpCode = this.otpCode.slice(0,-1);
    //   } 
    
    if(element == null)
      return;

    else
      {
      element.focus();
        if (element.value){
          
        }
      }
    
 }
}
